import React, { Component } from 'react';
import ItemEvento from './ItemEvento';
import NenhumRegistroEncontrado from './NenhumRegistroEncontrado';
import './Evento.css';
import { Config } from './Config.js';
import $ from 'jquery'

var cores = ['#ffffff', '#fafafa', '#f6f6f6', '#eeeeee'] 
class Evento extends Component {

    constructor(props) {
        super(props)
        this.state = {
            eventos: [],
            mostrarTudo: false
        }
        this.mostrarBotaoVerEncerrados = this.mostrarBotaoVerEncerrados.bind(this);
        this.mostrarEncerrados = this.mostrarEncerrados.bind(this);
    }

    componentDidMount() {
        var url = this.props.fase ? `${Config.eventoURL}/tipo${Config.basename}fase/${this.props.fase}` : `${Config.eventoURL}/tipo${Config.basename}`;

        $.ajax({
            url: url,
            dataType: 'json',
            cache: false,
            success: (result) => {
                this.setState({
                    eventos: result
                });
            }
        });

        //fetch(url)
        //    .then(res => {
        //        return res.json();
        //    })
        //    .then(
        //        (result) => {
        //            this.setState({
        //                eventos: result
        //            });
        //        },
        //        (error) => {
        //        }
        //    )
    }

    renderItemEvento(eventoNome, eventoVagas, EventoSalario, EventoURL, i) {
        return <ItemEvento key={i} EventoNome={eventoNome} EventoVagas={eventoVagas} EventoSalarioMaximo={EventoSalario} EventoURL={EventoURL} />;
    }

    renderEventoItems(eventos) {
        return eventos.map((x, i) => { return this.renderItemEvento(x.eventoNomeAbreviado, x.eventoTotalVagas, x.strEventoSalarioMaximo, `/${x.eventoURL}`, i) });
    }

    mostrarEncerrados() {
        this.setState({ mostrarTudo: true });
        this.render();
    }

    mostrarBotaoVerEncerrados() {
        console.log(this.state.eventos);
        if (!this.state.mostrarTudo && this.state.eventos && this.state.eventos.length > 0 && this.state.eventos.some(c => c.faseEvento == 'Encerrados')) {
            return (
                <div className="q_circle_text_holder SectionVerEncerrados" style={{ paddingBottom: '85px', paddingTop: '85px' }}>
                        <a data-itemprop="url" className="icon_with_title_link" href="encerrado" target="_self">Ver Encerrados</a>
                </div>);
        }
    }

    RenderEventosAgrupadosPorFase() {

        //var subProgramasParaMostrar = this.state.mostrarTudo ? this.state.subprogramas : this.state.subprogramas.filter(c => c.possuiEtapaVigente);
        var eventosParaMostrar = this.state.mostrarTudo ? this.state.eventos : this.state.eventos.filter(c => c.faseEvento != 'Encerrados');

        if (eventosParaMostrar && eventosParaMostrar.length > 0) {
            return eventosParaMostrar.map((x, i) => {
                return (
                    <div key={i} className="full_width_inner">
                        <div className="vc_row wpb_row section vc_row-fluid  grid_section bg-white" style={{ backgroundColor: x.faseEvento != 'Encerrados' ? cores[i] : '#ffffff', borderTop: '1px solid rgb(238, 238, 238)', paddingTop: '87px', paddingBottom: '80px', textAlign: 'left' }}>
                            <div className=" section_inner clearfix">
                                <div className="section_inner_margin clearfix">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                        <div className="vc_column-inner">
                                            <div className="wpb_wrapper" style={{ marginBottom: 0 }}>
                                                <div className="wpb_text_column wpb_content_element ">
                                                    <div className="wpb_wrapper">
                                                        <h1 className="text-center">{x.faseEvento}</h1>
                                                    </div>
                                                </div>
                                                <div className="separator small center"></div>
                                                <div className="separator transparent center"></div>
                                                <div className="itens-container">
                                                    <ul className="q_circles_holder five_columns no_line">
                                                        {this.renderEventoItems(x.eventos)}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            });
        }
        else
            return (<div><NenhumRegistroEncontrado TipoPagina={this.props.fase} /></div>)
    }

    render() {
        return (
            <div>
                <div className="title_outer animate_title_area with_image" data-height="500" style={{ opacity: '0', height: '100px' }}></div>
                <div className="full_width" style={{ paddingTop: '85px' }}>                   
                    {this.RenderEventosAgrupadosPorFase()}
                    {this.mostrarBotaoVerEncerrados()}
                </div>
            </div >
        );
    }
}

export default Evento;
